import { ELLO_APP_HOST, ELLO_PWA_HOST, ELLO_PWA_PATH } from "./elloDomains";
import { sessionLoginPath } from "./operatorStation";

/**
 * The product is identified by the actual origin, never by a query parameter,
 * localStorage preference, displayed role or caller-provided user data.
 * Access to an entity, license and screen remains enforced by the backend.
 */
export const productLoginPath = (
  pathname = typeof window !== "undefined" ? window.location.pathname : "/",
  hostname = typeof window !== "undefined" ? window.location.hostname : ""
) => {
  const host = String(hostname || "").trim().toLowerCase().replace(/\.$/, "");
  if (host === ELLO_PWA_HOST) return ELLO_PWA_PATH;
  if (host === ELLO_APP_HOST) return "/login";
  // The I9 terminal retains its unit-specific login; other I9 paths retain I9.
  return sessionLoginPath(pathname);
};

export const isSecurityRoute = pathname =>
  /^\/Security\/(?:recuperar-senha|validate-reset-code|reset-password|alterar-senha-primeiro-acesso)\/?$/i
    .test(String(pathname || ""));

/** A public password flow must not be interrupted by an expired old token. */
export const shouldKeepPublicAuthPage = (pathname, hostname) => {
  const path = String(pathname || "");
  const login = productLoginPath(path, hostname);
  return isSecurityRoute(path) || path === login ||
    /^\/producao\/login\/[^/]+\/?$/i.test(path);
};
